export default __webpack_public_path__ + "static/media/44_3_0.2e02bb64.png";